"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Module: ['module', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.523,3.345,12.785.705a3.029,3.029,0,0,0-1.57,0L1.477,3.345A2.028,2.028,0,0,0,0,5.276V17.818a2,2,0,0,0,1.343,1.889l10.141,3.528a2.957,2.957,0,0,0,1.01.164,2.838,2.838,0,0,0,1.043-.194l9.175-3.5A2.083,2.083,0,0,0,24,17.84h0V5.276A2.022,2.022,0,0,0,22.523,3.345ZM11.738,2.636a1.012,1.012,0,0,1,.524,0l6.157,1.669a.25.25,0,0,1,0,.482L12.555,6.473a.25.25,0,0,1-.133,0L5.786,4.732a.25.25,0,0,1,0-.483Zm-9.57,15.24A.25.25,0,0,1,2,17.64V6.131a.251.251,0,0,1,.1-.2.254.254,0,0,1,.216-.044l9,2.362a.25.25,0,0,1,.187.242V20.771a.247.247,0,0,1-.105.2.252.252,0,0,1-.227.033Z']],
  ModuleThree: ['module-three', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.25,11.25h7.5A1.752,1.752,0,0,0,17.5,9.5V2A1.752,1.752,0,0,0,15.75.25H8.25A1.752,1.752,0,0,0,6.5,2V9.5A1.752,1.752,0,0,0,8.25,11.25ZM8.75,5V4a1.5,1.5,0,0,1,1.5-1.5h1a.5.5,0,0,1,0,1h-1a.5.5,0,0,0-.5.5V5a.5.5,0,0,1-1,0Z', 'M9.25,12.75H1.75A1.752,1.752,0,0,0,0,14.5V22a1.752,1.752,0,0,0,1.75,1.75h7.5A1.752,1.752,0,0,0,11,22V14.5A1.752,1.752,0,0,0,9.25,12.75Zm-4,2.75a.5.5,0,0,1-.5.5h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,1-1,0v-1A1.5,1.5,0,0,1,3.75,15h1A.5.5,0,0,1,5.25,15.5Z', 'M22.25,12.75h-7.5A1.752,1.752,0,0,0,13,14.5V22a1.752,1.752,0,0,0,1.75,1.75h7.5A1.752,1.752,0,0,0,24,22V14.5A1.752,1.752,0,0,0,22.25,12.75Zm-4,2.75a.5.5,0,0,1-.5.5h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,1-1,0v-1a1.5,1.5,0,0,1,1.5-1.5h1A.5.5,0,0,1,18.25,15.5Z']],
  ModuleThree1: ['module-three-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.871,6.936a.254.254,0,0,0,.258,0l4.514-2.709a.249.249,0,0,0,.121-.214.252.252,0,0,0-.121-.215L12.515,1.321a1,1,0,0,0-1.029,0L7.357,3.8a.252.252,0,0,0-.121.215.249.249,0,0,0,.121.214Z', 'M12.5,8.154v4.417a.249.249,0,0,0,.127.218.252.252,0,0,0,.252,0l4.5-2.7a.252.252,0,0,0,.121-.215V5.454a.248.248,0,0,0-.127-.217.252.252,0,0,0-.252,0l-4.5,2.7A.25.25,0,0,0,12.5,8.154Z', 'M11.121,12.786a.252.252,0,0,0,.252,0,.249.249,0,0,0,.127-.218V8.154a.25.25,0,0,0-.121-.214l-4.5-2.7a.252.252,0,0,0-.252,0,.248.248,0,0,0-.127.217V9.871a.252.252,0,0,0,.121.215Z', 'M13.236,14.013a.249.249,0,0,0,.121.214l4.514,2.709a.254.254,0,0,0,.258,0l4.514-2.709a.249.249,0,0,0,.121-.214.252.252,0,0,0-.121-.215L18.129,11.09a.254.254,0,0,0-.258,0L13.357,13.8A.252.252,0,0,0,13.236,14.013Z', 'M18.5,18.154v4.417a.249.249,0,0,0,.127.218.252.252,0,0,0,.252,0L23.015,20.3a1,1,0,0,0,.485-.857V15.454a.248.248,0,0,0-.127-.217.252.252,0,0,0-.252,0l-4.5,2.7A.25.25,0,0,0,18.5,18.154Z', 'M12.627,15.237a.248.248,0,0,0-.127.217v4.417a.252.252,0,0,0,.121.215l4.5,2.7a.252.252,0,0,0,.252,0,.249.249,0,0,0,.127-.218V18.154a.25.25,0,0,0-.121-.214l-4.5-2.7A.252.252,0,0,0,12.627,15.237Z', 'M5.871,16.936a.254.254,0,0,0,.258,0l4.514-2.709a.249.249,0,0,0,.121-.214.252.252,0,0,0-.121-.215L6.129,11.09a.254.254,0,0,0-.258,0L1.357,13.8a.252.252,0,0,0-.121.215.249.249,0,0,0,.121.214Z', 'M11.373,15.237a.252.252,0,0,0-.252,0l-4.5,2.7a.25.25,0,0,0-.121.214v4.417a.249.249,0,0,0,.127.218.252.252,0,0,0,.252,0l4.5-2.7a.252.252,0,0,0,.121-.215V15.454A.248.248,0,0,0,11.373,15.237Z', 'M.986,20.3l4.135,2.482a.252.252,0,0,0,.252,0,.249.249,0,0,0,.127-.218V18.154a.25.25,0,0,0-.121-.214l-4.5-2.7a.252.252,0,0,0-.252,0,.248.248,0,0,0-.127.217v3.993A1,1,0,0,0,.986,20.3Z']],
  ModulePhonePuzzle1: ['module-phone-puzzle-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.74,21a3,3,0,0,0,3,3h8a2.95,2.95,0,0,0,.926-.149.5.5,0,0,0,.2-.829l-1.039-1.039L10.84,21,8.986,19.147A.5.5,0,0,0,8.633,19H3.241a.5.5,0,0,1-.5-.5L2.758,3a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1L12.74,8a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1l.014-4.994a3,3,0,0,0-3-3.009h-8a3,3,0,0,0-3,3Z', 'M22.967,16.864a1,1,0,0,0,0-1.414L21.64,14.122a.247.247,0,0,1-.07-.219.25.25,0,0,1,.14-.184,2,2,0,1,0-2.669-2.668.251.251,0,0,1-.4.07L17.31,9.793a1,1,0,0,0-1.414,0l-1.449,1.449a.5.5,0,0,0,.077.771,2,2,0,1,1-2.771,2.772.508.508,0,0,0-.769-.079l0,0-1.45,1.449a1,1,0,0,0,0,1.414l5.657,5.657a1,1,0,0,0,1.414,0l1.562-1.562a.5.5,0,0,0-.171-.819,2,2,0,1,1,2.593-2.593.5.5,0,0,0,.819.171Z']],
  ModulePhonePuzzle: ['module-phone-puzzle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.74,3a3,3,0,0,0-3-3h-8a3,3,0,0,0-3,3V21a3,3,0,0,0,3,3h8a2.922,2.922,0,0,0,.926-.15.5.5,0,0,0,.2-.828L8.987,19.147A.5.5,0,0,0,8.633,19H3.24a.5.5,0,0,1-.5-.5V5.5a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5V8a1,1,0,0,0,2,0Z', 'M22.967,16.864a1,1,0,0,0,0-1.414l-1.328-1.329a.25.25,0,0,1,.069-.4,1.966,1.966,0,0,0,.552-.391,2,2,0,1,0-3.219-2.276.251.251,0,0,1-.183.139.247.247,0,0,1-.219-.07L17.311,9.793a1,1,0,0,0-1.415,0l-1.449,1.449a.5.5,0,0,0,.077.771c.02.013.3.238.312.255a2,2,0,1,1-3.083,2.517.507.507,0,0,0-.768-.079l0,0-1.45,1.449a1,1,0,0,0,0,1.414l5.657,5.657a1,1,0,0,0,1.415,0l1.561-1.562a.5.5,0,0,0-.171-.819,2.006,2.006,0,0,1-1.123-1.109,2,2,0,0,1,3.268-2.167,2,2,0,0,1,.448.683.5.5,0,0,0,.819.171Z']],
  ModuleHandPuzzle1: ['module-hand-puzzle-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.633,5.846a2.016,2.016,0,0,1-.255-.311.5.5,0,0,0-.771-.077L9.158,6.907a1,1,0,0,0,0,1.414l5.657,5.657a1,1,0,0,0,1.414,0l1.562-1.562a.5.5,0,0,0-.171-.819A2,2,0,1,1,20.212,9a.5.5,0,0,0,.82.171l1.561-1.561a1,1,0,0,0,0-1.414L21.265,4.871a.247.247,0,0,1-.07-.219.251.251,0,0,1,.139-.183,1.966,1.966,0,0,0,.552-.391A2,2,0,1,0,19.058,1.25a1.966,1.966,0,0,0-.391.552.25.25,0,0,1-.4.069L16.936.543a1,1,0,0,0-1.414,0L14.073,1.992a.5.5,0,0,0,.077.772,1.953,1.953,0,0,1,.311.254,2,2,0,1,1-2.828,2.828Z', 'M2.114,14.5a1,1,0,0,0-1,1v7.25a1,1,0,0,0,2,0V15.5A1,1,0,0,0,2.114,14.5Z', 'M4.114,15.75v6.5a.5.5,0,0,0,.5.5H15.378a2.238,2.238,0,0,0,2.236-2.236V20.25a1,1,0,0,0-1-1H7.489a.625.625,0,0,1,0-1.25h2.525a1,1,0,0,0,.92-1.392A2.233,2.233,0,0,0,8.878,15.25H4.614A.5.5,0,0,0,4.114,15.75Z']],
  ModulePuzzle: ['module-puzzle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.123,8.3a.25.25,0,0,1,.157.426L1.008,12a.971.971,0,0,0,0,1.374l1.783,1.784a.5.5,0,0,0,.777-.088,3.79,3.79,0,0,1,.531-.665,3.886,3.886,0,0,1,5.5,5.5,3.837,3.837,0,0,1-.665.531.5.5,0,0,0-.088.777l1.784,1.784a.972.972,0,0,0,1.374,0l3.273-3.273a.25.25,0,0,1,.426.157,3.871,3.871,0,0,0,5.891,3,3.892,3.892,0,0,0,.715-6.066,3.822,3.822,0,0,0-2.428-1.11.25.25,0,0,1-.157-.426L22.992,12a.971.971,0,0,0,0-1.374L21.209,8.842a.5.5,0,0,0-.777.088A3.79,3.79,0,0,1,19.9,9.6a3.886,3.886,0,0,1-5.5-5.5,3.837,3.837,0,0,1,.665-.531.5.5,0,0,0,.088-.777L13.374,1.007a.972.972,0,0,0-1.374,0L8.727,4.28A.25.25,0,0,1,8.3,4.123a3.871,3.871,0,0,0-5.891-3A3.892,3.892,0,0,0,1.7,7.191,3.822,3.822,0,0,0,4.123,8.3Z']],
  ModuleHandsPuzzle: ['module-hands-puzzle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.031,15.632a22.622,22.622,0,0,0-1.52,3.926.246.246,0,0,0-.011.072v4.12a.25.25,0,0,0,.25.25h3.5a.25.25,0,0,0,.25-.25v-.972a.5.5,0,0,1,.148-.355c.567-.561,2.615-2.589,3.558-3.529a1,1,0,0,0,.294-.708V11.04a.5.5,0,0,0-.665-.472c-.73.255-1.8,1.388-1.834,5.828a.5.5,0,0,1-.147.35l-2.208,2.209a.25.25,0,0,1-.421-.232l.494-2.153C19.062,15.132,17.748,14.518,17.031,15.632Z', 'M1.165,10.568A.5.5,0,0,0,.5,11.04v7.1a1,1,0,0,0,.329.742c1.035.936,3,2.978,3.532,3.539a.5.5,0,0,1,.139.345v.98a.25.25,0,0,0,.25.25h3.5a.25.25,0,0,0,.25-.25V19.63a.246.246,0,0,0-.011-.072,22.622,22.622,0,0,0-1.52-3.926c-.717-1.114-2.031-.5-1.688.938l.493,2.153a.25.25,0,0,1-.42.232L3.146,16.746A.5.5,0,0,1,3,16.4C2.967,11.956,1.9,10.823,1.165,10.568Z', 'M7.768,5.6a2.016,2.016,0,0,1-.255-.311.5.5,0,0,0-.771-.077L5.293,6.657a1,1,0,0,0,0,1.414l5.657,5.657a1,1,0,0,0,1.414,0l1.561-1.562a.5.5,0,0,0-.171-.819A2,2,0,1,1,15.9,8.071a1.97,1.97,0,0,1,.448.683.5.5,0,0,0,.82.171l1.561-1.561a1,1,0,0,0,0-1.414L17.4,4.621a.247.247,0,0,1-.07-.219.251.251,0,0,1,.139-.183,1.966,1.966,0,0,0,.552-.391A2,2,0,1,0,14.8,1.552a.25.25,0,0,1-.4.069L13.071.293a1,1,0,0,0-1.414,0l-1.45,1.449a.5.5,0,0,0,.078.772,1.953,1.953,0,0,1,.311.254A2,2,0,1,1,7.768,5.6Z']],
  ModuleThree2: ['module-three-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.3,12.363,7.3,10.7a1.762,1.762,0,0,0-1.1,0l-5,1.666A1.748,1.748,0,0,0,0,14.024v6.559a1.747,1.747,0,0,0,1.2,1.66l5,1.667a1.741,1.741,0,0,0,1.1,0l5-1.666a1.749,1.749,0,0,0,1.2-1.661V14.024A1.8,1.8,0,0,0,12.3,12.363ZM6.67,12.12a.244.244,0,0,1,.08-.013.261.261,0,0,1,.079.012l2.844.948a.25.25,0,0,1,0,.474c-1.013.343-2.8.95-3.2,1.088a.247.247,0,0,1-.161,0l-2.877-.959a.25.25,0,0,1,0-.475Zm5.159,8.7-4.25,1.417A.25.25,0,0,1,7.25,22V16.107a.25.25,0,0,1,.171-.237l4.25-1.417a.251.251,0,0,1,.329.238v5.892A.25.25,0,0,1,11.829,20.82Z', 'M18.917,9.94A1.58,1.58,0,0,0,20,8.438V2.973a1.627,1.627,0,0,0-1.083-1.5L14.749.08a1.6,1.6,0,0,0-1,0L9.583,1.471A1.579,1.579,0,0,0,8.5,2.973V8.438a1.582,1.582,0,0,0,1.083,1.5l4.167,1.39a1.6,1.6,0,0,0,1,0Zm-3.839-.315a.25.25,0,0,1-.328-.237V4.842a.25.25,0,0,1,.171-.237l3.242-1.08a.247.247,0,0,1,.226.035.252.252,0,0,1,.1.205l-.047,4.574a.248.248,0,0,1-.172.234Zm-.8-8.121,1.9.633a.25.25,0,0,1,0,.474c-.756.257-1.891.645-2.2.753a.25.25,0,0,1-.162,0l-1.865-.622a.25.25,0,0,1,0-.474Z', 'M23.031,12.684,19.7,11.572a1.424,1.424,0,0,0-.894,0l-3.334,1.112a1.415,1.415,0,0,0-.968,1.344V18.4a1.414,1.414,0,0,0,.969,1.344L18.8,20.856a1.417,1.417,0,0,0,.895,0l3.333-1.11A1.416,1.416,0,0,0,24,18.4V14.028A1.457,1.457,0,0,0,23.031,12.684ZM19.223,13l.955.318a.25.25,0,0,1,0,.474c-.456.157-1,.346-1.205.419a.246.246,0,0,1-.163,0l-.891-.3a.25.25,0,0,1,0-.474Zm.857,6.166a.25.25,0,0,1-.33-.237V15.505l2.433-.812a.251.251,0,0,1,.329.234l.042,3.213a.248.248,0,0,1-.17.24Z']],
  ModuleBlocks: ['module-blocks', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.5,5a1,1,0,0,0-1-1H1.5a1,1,0,0,0-1,1V8a.5.5,0,0,0,.5.5H14a.5.5,0,0,0,.5-.5Z', 'M8,17.5a.5.5,0,0,0-.5-.5H1a.5.5,0,0,0-.5.5V22a1,1,0,0,0,1,1H7.542a.5.5,0,0,0,.493-.585A2.464,2.464,0,0,1,8,22Z', 'M7.5,16a.5.5,0,0,0,.5-.5V14a2.5,2.5,0,0,1,2.5-2.5H14a.5.5,0,0,0,.5-.5V10a.5.5,0,0,0-.5-.5H1a.5.5,0,0,0-.5.5v5.5A.5.5,0,0,0,1,16Z', 'M2.500 1.000 L5.500 1.000 L5.500 3.000 L2.500 3.000 Z', 'M9.500 1.000 L12.500 1.000 L12.500 3.000 L9.500 3.000 Z', 'M9.793,13.293A1,1,0,0,0,9.5,14v8a1,1,0,0,0,1,1h12a1,1,0,0,0,1-1V14a1,1,0,0,0-1-1h-12A1,1,0,0,0,9.793,13.293ZM20.5,15a1,1,0,1,1-1,1A1,1,0,0,1,20.5,15Zm0,4a1,1,0,1,1-1,1A1,1,0,0,1,20.5,19Zm-4-4a1,1,0,1,1-1,1A1,1,0,0,1,16.5,15Zm0,4a1,1,0,1,1-1,1A1,1,0,0,1,16.5,19Zm-4-4a1,1,0,1,1-1,1A1,1,0,0,1,12.5,15Zm0,4a1,1,0,1,1-1,1A1,1,0,0,1,12.5,19Z']],
  ModuleHandPuzzle: ['module-hand-puzzle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.811,8.35a2,2,0,0,1,3.276.683.5.5,0,0,0,.819.171l1.561-1.562a1,1,0,0,0,0-1.414L22.139,4.9a.252.252,0,0,1,.069-.4,2,2,0,1,0-2.276-3.219,2.037,2.037,0,0,0-.391.552.245.245,0,0,1-.183.139.249.249,0,0,1-.219-.069L17.811.571a1,1,0,0,0-1.415,0l-1.449,1.45a.5.5,0,0,0,.077.771,2,2,0,1,1-2.771,2.771.5.5,0,0,0-.771-.077l-1.45,1.449a1,1,0,0,0,0,1.415l5.657,5.656a1,1,0,0,0,1.415,0l1.561-1.561a.5.5,0,0,0-.171-.819,2,2,0,0,1-.683-3.276Z', 'M22.567,19.117a.514.514,0,0,0,.084-.86,2.48,2.48,0,0,0-2.411-.479l-3.425,1.136a.5.5,0,0,0-.29.252,1.994,1.994,0,0,1-1.785,1.112h-4a.5.5,0,0,1,0-1h4a1,1,0,1,0,0-2H11.326a.253.253,0,0,1-.152-.051A7,7,0,0,0,7.24,15.778H5.184A4,4,0,0,0,3.4,16.2L.378,17.709a.25.25,0,0,0-.138.224v5.394a.249.249,0,0,0,.382.212L4.04,21.4a.5.5,0,0,1,.424-.05C14.715,24.789,11.237,24.848,22.567,19.117Z']],
  ModuleFour: ['module-four', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.000 9.272 A3 1.5 0 1 0 15.000 9.272 A3 1.5 0 1 0 9.000 9.272 Z', 'M9.000 3.772 A3 1.5 0 1 0 15.000 3.772 A3 1.5 0 1 0 9.000 3.772 Z', 'M15.500 6.272 A3 1.5 0 1 0 21.500 6.272 A3 1.5 0 1 0 15.500 6.272 Z', 'M3.000 6.272 A3 1.5 0 1 0 9.000 6.272 A3 1.5 0 1 0 3.000 6.272 Z', 'M.9,17.492l9.649,4.2a.5.5,0,0,0,.7-.458v-8a.5.5,0,0,0-.3-.459L.7,8.313a.5.5,0,0,0-.7.459v7.344A1.5,1.5,0,0,0,.9,17.492Z', 'M12.75,13.228v8a.5.5,0,0,0,.7.458l9.65-4.2a1.5,1.5,0,0,0,.9-1.375V8.772a.5.5,0,0,0-.7-.459l-10.25,4.456A.5.5,0,0,0,12.75,13.228Z']]
};
exports["default"] = _default;